//Move bought with
window.addEventListener('load', function(){
  ele = document.getElementsByClassName('cbb-frequently-bought-container')[0];
  if (typeof(ele) != 'undefined' && ele != null)
  {
    targetele = document.getElementById('main-prod-desc');
    targetele.insertAdjacentElement('afterend', ele);
  }
});

/////////////////////////
var $labelPerson = $('#labelPerson'),
    $labelPersons = $('#labelPersons');
var ingredientListEl = $('#ingredient-list'),
    ingredientForm = $('.head-form');

if(ingredientForm.length) {
  var _this = this,
  increaseBtn = $('#increase-portion', ingredientForm),
  decreaseBtn = $('#decrease-portion'),
  initialPortionCountEl = $('#initial-portion-count', ingredientForm);  
  initialPortionCount = parseInt(initialPortionCountEl.text()),
  currentPortionCount = initialPortionCount,
  ingredientQtys = $('.qty');

  console.log(ingredientQtys);
  
  increaseBtn.on('click', function() {
    if(currentPortionCount < 10) {
      currentPortionCount ++;
      initialPortionCountEl.text(currentPortionCount);
      updateQty(currentPortionCount);
    }
  });

  decreaseBtn.on('click', function() {
    if(currentPortionCount > 1) {
      currentPortionCount --;

      initialPortionCountEl.text(currentPortionCount);
      updateQty(currentPortionCount);
    }
  });

  function updateQty(quantity) {
    var serves = parseInt(ingredientForm.data('serves')),
        _this = this;
    
    ingredientQtys.each(function () {
      var $element = $(this),
          originalQty = parseFloat($element.data('originalQty')),
          newQty;
      
      //get text part
      let strt = $element.text();
      let desinenza = strt.replace(/[^A-Z]+/gi,"");
      
      if (originalQty) {
        try {
          newQty = originalQty * quantity / serves;
          if (Math.round(newQty).toFixed(2) === (Math.round(newQty * 100) / 100).toFixed(2)) {
            //set to full number
            newQty = Math.round(newQty);
          } else {
            //set to 2 digits after comma
            newQty = newQty.toFixed(2);
          }

          newQty = parseFloat(newQty);
        } catch (e) {
          newQty = originalQty;
        }
      }

      $element.text(newQty + " " + desinenza);
    });

    $labelPersons.toggleClass('hidden', quantity === 1);
    $labelPerson.toggleClass('hidden', quantity !== 1);
  };
}




$("#showmorelink").on("click", function(e){
	$(".showmore").toggle(200);
  	$("#showmorelink").hide();
});

